<template>
    <div class="page order-bid">
        <div class="order-info">
            <div class="session-info">
                <div class="order-item-img">
                    <img class="img" :src="detail.pic" />
                </div>
                <div class="order-item-content">
                    <div class="film-name">{{ detail.filmName }}</div>
                    <div class="time">
                        {{ detail.showDateOfChinese }} {{ detail.movieInformation }}
                    </div>
                    <div class="cinema-name">{{ detail.cinemaName }}</div>
                    <div class="hall-name">{{ detail.hallName }}</div>
                    <div class="seat-list">
                        <div
                            class="seat-item"
                            v-if="detail.seats"
                            v-for="(item, index) in detail.seats"
                            :key="index"
                        >
                            {{ item.name }}
                        </div>
                    </div>
                    <div class="market-unit-price">市场价：￥{{ detail.marketUnitPrice }}/张</div>
                </div>
            </div>
            <!-- <div class="dividing-line">
                <div class="line-item"></div>
            </div>
            <div class="tip-list" @click="showTip">
                <div class="tip-item">
                    <img src="@/assets/icons/icon-close-red.png" />
                    <span>不支持退票</span>
                </div>
                <div class="tip-item">
                    <img src="@/assets/icons/icon-close-red.png" />
                    <span>不支持改签</span>
                </div>
                <div class="tip-item">
                    <img src="@/assets/icons/icon-voice-red.png" />
                    <span>退改签须知</span>
                </div>
            </div> -->
        </div>
        <div class="bidding-step-info">
            <div class="line line-order">
                <div class="key">订单编号</div>
                <div class="value">{{ detail.orderNo }}</div>
                <div
                    class="copy"
                    v-clipboard:copy="detail.orderNo"
                    v-clipboard:success="copySuccess"
                >
                    复制
                </div>
            </div>
            <div class="line line-create-time">
                <div class="key">创建时间</div>
                <div class="value">{{ detail.createTime }}</div>
            </div>
            <div class="separator"></div>
            <div class="step-list">
                <div class="step-item step-1">
                    <div class="title">订单创建</div>
                    <div class="p">您的订单已成功创建</div>
                    <div class="p">{{ detail.createTime }}</div>
                </div>
                <div class="step-item step-2" v-if="detail.saveAmount == 0">
                    <div class="title">
                        竞价中
                        <span class="time">{{ userBiddingTime }}</span>
                    </div>
                    <div class="p">
                        系统正努力为您筛选最优价格。客官要是觉得价格合适,可立即支付出票。
                    </div>
                    <!-- <div class="btn">
                        取消订单
                    </div> -->
                </div>
                <div class="step-item step-2" v-else>
                    <div class="title" v-if="userBiddingTimer">
                        竞价中
                        <span class="time">{{ userBiddingTime }}</span>
                    </div>
                    <div class="title" v-else>竞价成功</div>
                    <div class="p">系统为您找到了一个最优的价格：</div>
                    <div class="p red">
                        <span>
                            <animate-number
                                v-if="seatPriceIsReload"
                                ref="seatPriceRef"
                                mode="manual"
                                :from="seatPriceForm"
                                :to.sync="seatPriceTo"
                                :duration="400"
                                :formatter="priceFormatter"
                            />
                        </span>
                        元/座（该订单立省
                        <span>
                            <animate-number
                                v-if="saveAmountIsReload"
                                ref="saveAmountRef"
                                mode="manual"
                                :from="saveAmountForm"
                                :to.sync="saveAmountTo"
                                :duration="400"
                                :formatter="priceFormatter"
                            />
                        </span>
                        元）
                    </div>
                </div>
                <div class="step-item step-3" v-if="detail.saveAmount != 0 && !userBiddingTimer">
                    <div class="title">
                        等待支付
                        <span class="time">{{ downTime }}</span>
                    </div>
                    <div class="p">超时未支付可能导致无法再次比价购买哦~</div>
                </div>
            </div>
        </div>
        <div class="footer">
            <!-- <div class="tip"></div> -->
            <div class="btn" @click="pay">立即支付 ( {{ downTime }} )</div>
        </div>
        <div class="popup" v-if="showPopupStatus" @click="hideTip">
            <div class="tip-message iphone-x-adaptation" @click.stop="">
                <div class="title">退改签须知</div>
                <div class="content">
                    <p class="bold">关于退票：</p>
                    <p>
                        排队中的订单，您可以在首页电影-订单-点击进入后，自行申请取消订单，完成取消后我们将原路退回您的款项；出单中和已出票的订单不支持退票。
                    </p>
                    <p class="bold">关于改签：</p>
                    <p>
                        排队中的订单，您可以在首页电影-订单-点击进入后，自行申请取消订单，完成取消后我们将原路退回您的款项；出单中和已出票的订单不支持改签。
                    </p>
                </div>
                <div class="iphone-x-adaptation-padding iphone-x-adaptation"></div>
                <img class="close" src="~@/assets/icons/icon-close.png" @click="hideTip" />
            </div>
        </div>
    </div>
</template>

<script>
import { GET_ORDER_INFO_FOR_ORDER_NO } from 'api';
import { PAGE_ORDER_INFO } from 'page';
import pay from 'pay';
import moment from 'moment';
import number from '@/lib/number';
export default {
    data() {
        return {
            pageTimer: null,
            orderNo: '',
            detail: {},
            showPopupStatus: false,
            downTimer: null,
            downTime: '',
            userBiddingTimer: null,
            userBiddingTime: '',
            // 滚动价格 - 当前每座平均价格
            // 上次的价格，默认为市场价
            seatPriceLast: 0,
            // 渲染的初始价格
            seatPriceForm: 0,
            // 渲染的目标价格
            seatPriceTo: 0,
            // 需要执行的随机减少金额数组
            seatPriceReduceList: [],
            // 价格滚动的定时器
            seatPriceTimer: null,
            // 重制渲染
            seatPriceIsReload: true,
            // 滚动价格 - 立省金额
            // 上次的价格，默认为市场价
            saveAmountLast: 0,
            // 渲染的初始价格
            saveAmountForm: 0,
            // 渲染的目标价格
            saveAmountTo: 0,
            // 需要执行的随机减少金额数组
            saveAmountReduceList: [],
            // 价格滚动的定时器
            saveAmountTimer: null,
            // 重制渲染
            saveAmountIsReload: true,
        };
    },
    watch: {
        showPopupStatus(val) {
            if (val) {
                this.$util.lockScreen();
            } else {
                this.$util.unlockScreen();
            }
        },
        seatPriceIsReload(val) {
            if (!val) {
                setTimeout(() => {
                    this.seatPriceIsReload = true;
                    this.$nextTick(() => {
                        if (this.$refs.seatPriceRef) {
                            this.$refs.seatPriceRef.start();
                        }
                    });
                }, 0);
            }
        },
        seatPriceTo() {
            this.seatPriceIsReload = false;
        },
        saveAmountIsReload(val) {
            if (!val) {
                setTimeout(() => {
                    this.saveAmountIsReload = true;
                    this.$nextTick(() => {
                        if (this.$refs.saveAmountRef) {
                            this.$refs.saveAmountRef.start();
                        }
                    });
                }, 0);
            }
        },
        saveAmountTo() {
            this.saveAmountIsReload = false;
        },
    },
    created() {
        this.$toast('60秒完成比价，请勿离开哦~', 5000);
        this.orderNo = this.$route.query.orderNo;
        this.setPageTimer();
        this.getMovieInfo();
    },
    methods: {
        priceFormatter(value) {
            return value.toFixed(2);
        },
        setPageTimer() {
            this.pageTimer = setInterval(() => {
                if (this._isDestroyed) {
                    clearInterval(this.pageTimer);
                    return;
                }
                this.getMovieInfo();
            }, 5 * 1000);
        },
        getMovieInfo() {
            this.$util
                .get(GET_ORDER_INFO_FOR_ORDER_NO, {
                    orderNo: this.orderNo,
                })
                .then(res => {
                    this.orderInfoResNext(res);
                });
        },
        orderInfoResNext(res) {
            if (res.success) {
                // 凭借电影信息说明 start
                res.data.movieInformation =
                    moment(res.data.showTime).format('M月D日 HH:mm') + ' ' + res.data.versionTypes;
                // 凭借电影信息说明 end
                // 是否同意调座
                this.detail = res.data;

                if (this.seatPriceLast == 0) {
                    this.seatPriceLast = res.data.unitPrice;
                    this.seatPriceForm = res.data.unitPrice;
                    this.seatPriceTo = res.data.unitPrice;

                    this.saveAmountLast = res.data.saveAmount;
                    this.saveAmountForm = res.data.saveAmount;
                    this.saveAmountTo = res.data.saveAmount;
                }
                console.log(this.seatPriceLast, res.data.unitPrice);
                if (this.seatPriceLast < res.data.unitPrice) {
                    this.seatPriceForm = this.seatPriceLast;
                    this.seatPriceTo = res.data.unitPrice;

                    this.saveAmountForm = this.saveAmountLast;
                    this.saveAmountTo = res.data.saveAmount;
                }
                try {
                    if (this.seatPriceLast != res.data.unitPrice) {
                        this.seatPriceReduceList = [];
                        this.saveAmountReduceList = [];
                        let randomNum = Math.floor(Math.random() * 3) + 3;
                        while (this.seatPriceReduceList.length < randomNum) {
                            // 计算每个座位的平均价
                            let allocatedAmount = 0;
                            this.seatPriceReduceList.map(v => {
                                allocatedAmount = number.operation(`${allocatedAmount}+${v}`);
                            });
                            let remainingChangeAmount = number.operation(
                                `${number.operation(
                                    `${this.seatPriceLast}-${res.data.unitPrice}`
                                )}-${allocatedAmount}`
                            );

                            if (this.seatPriceReduceList.length == randomNum - 1) {
                                this.seatPriceReduceList.push(remainingChangeAmount);
                                // 计算立省金额
                                this.saveAmountReduceList.push(
                                    number.operation(
                                        `${remainingChangeAmount}*${res.data.seatsCount}`
                                    )
                                );
                            } else {
                                let remainingAverageChangeAmount = (+number.operation(
                                    `${remainingChangeAmount}/${
                                        randomNum - this.seatPriceReduceList.length
                                    }`
                                )).toFixed(4);
                                let tempChangeAmount = (+(
                                    Math.random() * remainingAverageChangeAmount
                                )).toFixed(2);

                                this.seatPriceReduceList.push(tempChangeAmount);

                                // 计算立省金额
                                this.saveAmountReduceList.push(
                                    number.operation(`${tempChangeAmount}*${res.data.seatsCount}`)
                                );
                            }
                        }
                        this.setRollingPrice();
                    }

                    this.setUserBiddingTime();
                } catch (error) {
                    this.seatPriceLast = res.data.unitPrice;
                    this.seatPriceForm = res.data.unitPrice;
                    this.seatPriceTo = res.data.unitPrice;

                    this.saveAmountLast = res.data.saveAmount;
                    this.saveAmountForm = res.data.saveAmount;
                    this.saveAmountTo = res.data.saveAmount;
                }

                this.setDownTime();

                if (this.detail.status != 0) {
                    if (this.pageTimer) {
                        clearInterval(this.pageTimer);
                    }
                    // TODO
                    // this.$util.pageJump({
                    //     path: PAGE_ORDER_INFO,
                    //     query: {
                    //         orderNo: this.detail.orderNo,
                    //     },
                    //     config: {
                    //         jumpType: 1,
                    //     },
                    // });
                }
            }
        },
        setRollingPrice() {
            if (this.seatPriceTimer) {
                clearInterval(this.seatPriceTimer);
                this.seatPriceTimer = null;
            }
            this.seatPriceTimer = setInterval(() => {
                if (this._isDestroyed) {
                    clearInterval(this.seatPriceTimer);
                    this.seatPriceTimer = null;
                    return;
                }
                if (this.seatPriceReduceList.length > 0) {
                    this.setRollingPriceView();
                }
            }, ~~number.operation(`${5000}/${this.seatPriceReduceList.length}`));
            this.setRollingPriceView();
        },
        setRollingPriceView() {
            this.seatPriceForm = this.seatPriceTo;
            this.seatPriceTo = number.operation(
                `${this.seatPriceTo}-${this.seatPriceReduceList[0]}`
            );
            this.seatPriceReduceList.shift();

            this.saveAmountForm = this.saveAmountTo;
            this.saveAmountTo = number.operation(
                `${this.saveAmountTo}+${this.saveAmountReduceList[0]}`
            );
            this.saveAmountReduceList.shift();

            if (this.seatPriceReduceList.length == 0) {
                this.seatPriceLast = this.detail.unitPrice;
                this.saveAmountLast = this.detail.saveAmount;
                clearInterval(this.seatPriceTimer);
                this.seatPriceTimer = null;
            }
        },
        setDownTime() {
            if (this.downTimer) {
                clearInterval(this.downTimer);
            }
            this.downTimer = setInterval(() => {
                this.setDownTimeText();
            }, 1000);
            this.setDownTimeText();
        },
        setDownTimeText() {
            if (this.detail.status == 0) {
                let auctionEndTime = moment(this.detail.startAuctionTime).add('m', 3).format('X');
                let nowTime = moment().format('X');
                let tempDownTime = auctionEndTime - nowTime;
                if (tempDownTime < 1 && this.downTimer) {
                    clearInterval(this.downTimer);
                    // TODO
                    // this.$util.pageJump({
                    //     path: PAGE_ORDER_INFO,
                    //     query: {
                    //         orderNo: this.detail.orderNo,
                    //     },
                    //     config: {
                    //         jumpType: 1,
                    //     },
                    // });
                }
                this.downTime = `${this.repairZero(~~(tempDownTime / 60))}:${this.repairZero(
                    tempDownTime % 60
                )}`;
            } else {
                this.downTime = '00:00';
                if (this.downTimer) {
                    clearInterval(this.downTimer);
                }
            }
        },
        setUserBiddingTime() {
            if (this.userBiddingTimer) {
                clearInterval(this.userBiddingTimer);
                this.userBiddingTimer = null;
            }
            this.userBiddingTimer = setInterval(() => {
                this.setUserBiddingTimeText();
            }, 1000);
            this.setUserBiddingTimeText();
        },
        setUserBiddingTimeText() {
            if (this.detail.status == 0) {
                let auctionEndTime = moment(this.detail.startAuctionTime).add('m', 1).format('X');
                let nowTime = moment().format('X');
                let tempDownTime = auctionEndTime - nowTime;
                if (tempDownTime < 1 && this.userBiddingTimer) {
                    clearInterval(this.userBiddingTimer);
                    this.userBiddingTimer = null;
                    return;
                }
                this.userBiddingTime = `${this.repairZero(~~(tempDownTime / 60))}:${this.repairZero(
                    tempDownTime % 60
                )}`;
            } else {
                this.userBiddingTime = '00:00';
                if (this.userBiddingTimer) {
                    clearInterval(this.userBiddingTimer);
                    this.userBiddingTimer = null;
                }
            }
        },
        pay() {
            pay({
                orderType: 5,
                orderId: this.detail.id,
                orderNo: this.detail.orderNo,
            }).then(payRes => {
                if (payRes.success) {
                } else {
                    this.$toast(payRes.message);
                }
            });
        },
        repairZero(n) {
            return n < 10 ? '0' + n : n;
        },
        showTip() {
            this.showPopupStatus = true;
        },
        hideTip() {
            this.showPopupStatus = false;
        },
        copySuccess() {
            this.$toast('复制成功');
        },
    },
};
</script>

<style lang="less" scoped>
@import url('~@/lib/base.less');
@footerHeight: .pxToRem(0) [];
.order-bid {
    .order-info {
        background: white;
        margin: .pxToRem(20) [] .pxToRem(30) [] .pxToRem(0) [];
        border-radius: .pxToRem(40) [];
        .session-info {
            display: flex;
            padding: .pxToRem(40) [] .pxToRem(30) [] .pxToRem(30) [] .pxToRem(30) [];
            .order-item-img {
                width: .pxToRem(160) [];
                height: .pxToRem(210) [];
                border-radius: .pxToRem(16) [];
                overflow: hidden;
                .img {
                    width: 100%;
                    height: 100%;
                }
            }
            .order-item-content {
                flex: 1;
                margin-left: .pxToRem(30) [];
                .film-name {
                    line-height: .pxToRem(40) [];
                    font-size: .pxToRem(40) [];
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.9);
                    margin-bottom: .pxToRem(12) [];
                }
                .time,
                .cinema-name,
                .hall-name {
                    line-height: .pxToRem(36) [];
                    font-size: .pxToRem(24) [];
                    color: rgba(0, 0, 0, 0.9);
                }
                .seat-list {
                    margin-top: .pxToRem(12) [];
                    .seat-item {
                        display: inline-block;
                        padding: .pxToRem(4) [] .pxToRem(12) [];
                        border: .pxToRem(1) [] solid #313131;
                        line-height: .pxToRem(36) [];
                        font-size: .pxToRem(24) [];
                        color: rgba(0, 0, 0, 0.9);
                        border-radius: .pxToRem(8) [];
                        margin-right: .pxToRem(8) [];
                        margin-bottom: .pxToRem(8) [];
                    }
                }
                .market-unit-price {
                    height: .pxToRem(38) [];
                    line-height: .pxToRem(38) [];
                    font-size: .pxToRem(24) [];
                    color: rgba(0, 0, 0, 0.5);
                }
            }
        }
        .dividing-line {
            height: .pxToRem(40) [];
            .line-item {
                .base-center;
                width: .pxToRem(630) [];
                height: .pxToRem(1) [];
                background: rgba(0, 0, 0, 0.15);
            }
            &::before {
                content: ' ';
                .base-center-y;
                left: 0;
                height: .pxToRem(36) [];
                width: .pxToRem(18) [];
                background: #f5f5f5;
                border-top-right-radius: .pxToRem(18) [];
                border-bottom-right-radius: .pxToRem(18) [];
            }
            &::after {
                content: ' ';
                .base-center-y;
                right: 0;
                height: .pxToRem(36) [];
                width: .pxToRem(18) [];
                background: #f5f5f5;
                border-top-left-radius: .pxToRem(18) [];
                border-bottom-left-radius: .pxToRem(18) [];
            }
        }
        .tip-list {
            display: flex;
            padding: .pxToRem(0) [] .pxToRem(64) [] .pxToRem(14) [] .pxToRem(30) [];
            height: .pxToRem(76) [];
            line-height: .pxToRem(76) [];
            justify-content: space-between;
            align-items: center;
            .tip-item {
                display: flex;
                align-items: center;
                justify-content: center;
                color: #d90209;
                font-size: .pxToRem(28) [];
                font-weight: bold;
                img {
                    .sq(32);
                }
                span {
                    margin-left: .pxToRem(10) [];
                }
                &:last-child {
                    color: rgba(0, 0, 0, 0.9);
                    font-weight: bold;
                }
            }
            &:before {
                content: ' ';
                position: absolute;
                top: .pxToRem(26) [];
                right: .pxToRem(30) [];
                .sq(24);
                background: url(~@/assets/icons/icon-right.png);
                background-size: cover;
            }
        }
    }
    .bidding-step-info {
        width: .pxToRem(690) [];
        background: #ffffff;
        box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] 0 rgba(0, 0, 0, 0.08);
        border-radius: .pxToRem(40) [];
        margin: 0 auto;
        margin-top: .pxToRem(18) [];
        margin-bottom: .pxToRem(18) [];
        box-sizing: border-box;
        padding: .pxToRem(24) [] .pxToRem(30) [];
        .line {
            display: flex;
            justify-content: space-between;
            height: .pxToRem(78) [];
            line-height: .pxToRem(78) [];
            .key {
                flex: 1;
                color: rgba(0, 0, 0, 0.9);
                font-size: .pxToRem(28) [];
            }
            .value {
                color: rgba(0, 0, 0, 0.5);
                font-size: .pxToRem(28) [];
            }
            .copy {
                color: rgba(0, 0, 0, 0.9);
                font-size: .pxToRem(28) [];
                margin-left: .pxToRem(20) [];
            }
        }
        .separator {
            width: .pxToRem(630) [];
            height: .pxToRem(1) [];
            background: rgba(0, 0, 0, 0.15);
            border-radius: .pxToRem(1) [];
            margin-top: .pxToRem(14) [];
        }
    }
    .step-list {
        .step-item {
            padding-left: .pxToRem(66) [];
            margin-top: .pxToRem(40) [];
            .title {
                display: flex;
                align-items: center;
                height: .pxToRem(44) [];
                font-size: .pxToRem(34) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.9);
                line-height: .pxToRem(44) [];
                .time {
                    line-height: .pxToRem(40) [];
                    height: .pxToRem(40) [];
                    font-size: .pxToRem(24) [];
                    font-weight: bold;
                    color: #f7b500;
                    border-radius: .pxToRem(8) [];
                    border: .pxToRem(2) [] solid #f8c32f;
                    padding: 0 .pxToRem(10) [];
                    margin-left: .pxToRem(48) [];
                    &::before {
                        content: ' ';
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        left: .pxToRem(-44) [];
                        width: .pxToRem(40) [];
                        height: .pxToRem(40) [];
                        background: url('~@/assets/icons/icon-clock.png');
                        background-size: contain;
                        background-repeat: no-repeat;
                    }
                }
            }
            .p {
                margin-top: .pxToRem(4) [];
                line-height: .pxToRem(44) [];
                font-size: .pxToRem(28) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.5);
            }
            .red {
                color: #d90209;
            }
            .btn {
                display: inline-block;
                height: .pxToRem(60) [];
                line-height: .pxToRem(60) [];
                font-size: .pxToRem(26) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.9);
                padding: 0 .pxToRem(22) [];
                border: .pxToRem(1) [] solid #313131;
                border-radius: .pxToRem(30) [];
            }

            &::before {
                content: ' ';
                position: absolute;
                top: 0;
                left: .pxToRem(0) [];
                width: .pxToRem(44) [];
                height: .pxToRem(44) [];
                background: url('~@/assets/icons/icon-choose.png');
                background-size: contain;
                background-repeat: no-repeat;
                z-index: 2;
            }
            &::after {
                content: ' ';
                position: absolute;
                top: .pxToRem(22) [];
                left: .pxToRem(21) [];
                bottom: .pxToRem(-62) [];
                width: .pxToRem(2) [];
                background: #f8c32f;
                z-index: 1;
            }
            &:last-child {
                &::after {
                    display: none;
                }
            }
        }
    }
    .footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        .tip {
            text-align: center;
            color: rgba(0, 0, 0, 0.5);
            font-size: .pxToRem(26)[];
            padding: .pxToRem(10)[] 0;
        }
        .btn {
            text-align: center;
            line-height: .pxToRem(100) [];
            background: @theme_color_first;
            box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] .pxToRem(0) []
                rgba(0, 0, 0, 0.08);
            border-radius: .pxToRem(40) [] .pxToRem(40) [] 0 0;
        }
    }
    .popup {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: @footerHeight;
        background: rgba(0, 0, 0, 0.8);
        z-index: 99;
        .tip-message {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: white;
            border-top-left-radius: .pxToRem(40) [];
            border-top-right-radius: .pxToRem(40) [];
            .title {
                height: .pxToRem(106) [];
                line-height: .pxToRem(106) [];
                text-align: center;
                font-size: .pxToRem(32) [];
                font-weight: bold;
                color: rgba(0, 0, 0, 0.9);
                &:after {
                    content: ' ';
                    position: absolute;
                    bottom: 0;
                    left: .pxToRem(50) [];
                    right: .pxToRem(50) [];
                    height: .pxToRem(1) [];
                    background: rgba(0, 0, 0, 0.1);
                }
            }
            .content {
                padding: 0 .pxToRem(50) [];
                padding-bottom: .pxToRem(50) [];
                .bold {
                    margin-top: .pxToRem(30) [];
                    color: rgba(0, 0, 0, 0.9);
                }
                p {
                    margin-top: .pxToRem(10) [];
                    font-size: .pxToRem(28) [];
                    color: rgba(0, 0, 0, 0.5);
                    line-height: .pxToRem(44) [];
                }
            }
            .close {
                position: absolute;
                top: .pxToRem(37) [];
                right: .pxToRem(50) [];
                .sq(32);
            }
        }
    }
}
</style>
